import SectionBox from "PFComponents/box/section_box";
import Modal from "PFComponents/modal/modal";
import React from "react";

import css from "../modals.module.scss";

type IProps = { qaId: string; handleClose: () => void; children: React.ReactNode };

const Content = ({ children, handleClose }: { children: React.ReactNode; handleClose?: () => void }) => (
  <SectionBox>
    {/* @ts-ignore */}
    <div className={css.modal}>{React.cloneElement(children, { handleClose })}</div>
  </SectionBox>
);

const ApprovalModal = ({ qaId, handleClose, children }: IProps) => (
  //@ts-ignore-line
  <Modal
    qaId={qaId}
    closeOnBackdropClick
    handleClose={handleClose}
    style={{ maxWidth: 900, margin: "0 auto", transform: "translateY(-25px)" }}
    handleBeforeClose={() => {}}
  >
    <Content>{children}</Content>
  </Modal>
);

export default ApprovalModal;
